/** L&G logo with dark lettering, for light backgrounds */
export const landgLogoUrl = 'https://cms.legalandgeneral.com/globalassets/global-shared-assets/logos/landg_logo.svg';

/**
 * L&G logo with white lettering, shown in dark mode (apps/shared/src/assets/images, copied into every app).
 * Pair it with landgLogoUrl: give the light <img> `logo-light-only` and this one `logo-dark-only` (see _theme.scss).
 */
export const landgLogoDarkUrl = 'assets/images/landg-logo-dark.png';
